import type { TeachingExperienceYears } from '../enums'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface TeachingExperienceYearsReturn {
  label: string
  mode: ComputedRef<InputMode>
  setTeachingExperienceYears: (value: TeachingExperienceYears) => void
}

export const useTeachingExperienceYears = (): TeachingExperienceYearsReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'How many years of teaching experience do you have?'

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.getTeachingExperienceYears))
  
  const setTeachingExperienceYears = (value: TeachingExperienceYears): void => {
    tutorApplicationStore.setTeachingExperienceYears(value)
  }

  return {
    mode,
    label,
    setTeachingExperienceYears,
  }
}
